import { CLOUDINARY } from "../constants";

export const uploadToCloudinary = async (file) => {
  const endpoint = `https://api.cloudinary.com/v1_1/${CLOUDINARY.cloudName}/image/upload`;

  const fd = new FormData();
  fd.append("file", file);
  fd.append("upload_preset", CLOUDINARY.uploadPreset);
  fd.append("folder", CLOUDINARY.folder);

  const res = await fetch(endpoint, { method: "POST", body: fd });
  const data = await res.json();

  if (!res.ok || !data?.secure_url) {
    throw new Error(data?.error?.message || "Cloudinary upload failed");
  }

  return data.secure_url;
};
